module.exports = function(PluginManager) {
  PluginManager.registerVisitorProfileProvider(require('./providers/behavior_events'));
  PluginManager.registerAudienceMatcher('behavior', require('./matchers/behavior'));
};
